import Axios from 'axios'

export const attendeeAccessTokenkey = 'attendee_access_token'

export function attendeeApiClient() {
  const get = async <T = any>(url: string): Promise<T> => {
    const res = await axios().get<T>(url)
    return res.data
  }

  const post = async <T = any>(url: string, data?: any): Promise<T> => {
    const res = await axios().post<T>(url, data)
    return res.data
  }

  const del = async <T = any>(url: string, data?: any): Promise<T> => {
    const res = await axios().delete<T>(url, {data})
    return res.data
  }

  return {
    get,
    post,
    delete: del,
  }
}

function getAccessToken() {
  return localStorage.getItem(attendeeAccessTokenkey)
}

function axios() {
  const instance = Axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data;',
      Authorization: 'Bearer ' + getAccessToken(),
    },
  })

  return instance
}
